import { Link, useForm } from '@inertiajs/react'

import { Wordmark } from '../../components/Wordmark'
import { Button } from '@/components/ui/button'
import { Field } from '@/components/ui/label'
import { Input } from '@/components/ui/input'

interface Props {
  error?: string
}

/**
 * Spec 11 · Admin login — the shop's own chrome, not a generic form:
 * bone page, the mark, a hairline card, and one accent action.
 */
export default function AdminLogin({ error }: Props) {
  const { data, setData, post, processing } = useForm({
    email: '',
    password: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/admin/login')
  }

  return (
    <div className="sss-admin flex min-h-dvh items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-[400px]">
        <div className="mb-8 text-center">
          <Wordmark size={44} className="text-signal" />
          <p className="mt-2 text-[13px] font-medium text-ink-muted">Admin</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-[18px] rounded-md border border-hairline bg-surface p-6"
        >
          {error && (
            <div
              role="alert"
              className="flex items-center gap-3 rounded-md border border-destructive bg-surface px-4 py-3 text-[12px] text-destructive"
            >
              <span className="size-1.5 shrink-0 rounded-full bg-destructive" />
              {error}
            </div>
          )}

          <Field label="Email" htmlFor="email" required>
            <Input
              id="email"
              type="email"
              value={data.email}
              onChange={(e) => setData('email', e.target.value)}
              required
              autoFocus
              autoComplete="username"
            />
          </Field>

          <Field label="Password" htmlFor="password" required>
            <Input
              id="password"
              type="password"
              value={data.password}
              onChange={(e) => setData('password', e.target.value)}
              required
              autoComplete="current-password"
            />
          </Field>

          <Button type="submit" variant="primary" size="block" processing={processing}>
            {processing ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <Link
            href="/"
            className="text-[13px] font-medium text-ink-muted hover:text-signal-deep"
          >
            ← Back to store
          </Link>
        </div>
      </div>
    </div>
  )
}
